@if(showHeader){
<fgb-banner [pageTitle]="title" *notInPopulation="[populations.Kids]"> </fgb-banner>
<ng-container *inPopulation="[populations.Kids]">
  <div class="img-banner-container d-none d-lg-block" role="banner">
    <div class="container">
      <img [src]="bannerImage | contentAssetImage" alt="kid banner" class="w-100" />
    </div>
  </div>
</ng-container>
<fgb-page-header [pageTitle]="mobileTitle" [backButtonLink]="'/'" [showBalance]="!isWalletPage" [showFooter]="!isWalletPage">
  <ng-template>
    <div class="pb-3" *inPopulation="[populations.Kids]" [ngClass]="{ 'd-none': isWalletPage }">
      <img [src]="bannerImage | contentAssetImage" alt="kid banner" class="w-100 rounded" />
    </div>
  </ng-template>
</fgb-page-header>
<div class="mobile-content-wrapper pt-lg-4 pb-4" *ngIf="!isMobileNavDisabled">
  <div class="container">
    <fgb-route-nav indicatorStyle="rounded" (onTabChange)="title = $event">
      <a
        class="nav-item"
        [routerLink]="['/rewards/raffles']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <label>{{ 'rewards.nav.lotto' | translate }}</label>
        <div class="nav-item-bg"></div>
      </a>
      <a
        class="nav-item d-lg-flex d-none"
        [routerLink]="['/rewards/wallet']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <label>{{ 'rewards.nav.wallet' | translate }}</label>
        <div class="nav-item-bg"></div>
      </a>
    </fgb-route-nav>
  </div>
</div>
}
<router-outlet></router-outlet>
